module.exports = __webpack_public_path__ + "assets/img/xiaoshou--blue.53838e8e.png";